import { createSelector } from "reselect";
import getCanAutoplaySilentVideo from "selectors/device/getCanAutoplaySilentVideo";
import getIsAndroid from "selectors/device/getIsAndroid";
import getWaitingForInitialPlay from "selectors/device/getWaitingForInitialPlay";

const getHasBlankVideo = (state, ownProps) => !!ownProps.hasBlankVideo;

const getShowStoryCoverPosterImage = createSelector(
  [
    getCanAutoplaySilentVideo,
    getHasBlankVideo,
    getIsAndroid,
    getWaitingForInitialPlay,
  ],
  (canAutoplaySilentVideo, hasBlankVideo, isAndroid, waitingForInitialPlay) =>
    !canAutoplaySilentVideo &&
    (hasBlankVideo || (isAndroid && waitingForInitialPlay)),
);

export default getShowStoryCoverPosterImage;
